import { z } from 'my-zod'
import { vehicleSystemView } from '.'

export const vehicleWarehouseView = vehicleSystemView.pick({
  id: true,
  modelId: true,
  vin: true,
  contractedPickupDate: true,
  lifecycleStatus: true,
  vehicleImei: true,
  lastModifiedDate: true
})

export type vehicleWarehouseView = z.infer<typeof vehicleWarehouseView>
